import { render, staticRenderFns } from "./OrderDraftShipping.vue?vue&type=template&id=743a29a3&"
import script from "./OrderDraftShipping.vue?vue&type=script&lang=js&"
export * from "./OrderDraftShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports